import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'

// Define custom claims type for better type safety
export interface CustomClaims {
  role?: string
  permissions?: string[]
  scopes?: string[]
  [key: string]: unknown
}

export interface AuthContextType {
  user: import('firebase/auth').User | null
  claims: CustomClaims | null
  loading: boolean
  isAuthenticated: boolean
  getToken: () => Promise<string | null>
  refreshClaims: () => Promise<void>
}

// Custom hook to use auth context
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
